<div #viewport class="hierarchy-viewport" [class.panning]="isPanning"
     (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)" (pointercancel)="onPointerUp($event)">
  <div #canvas class="hierarchy-canvas" [ngClass]="'canvas-' + orientation" [style.zoom]="exportMode ? 1 : zoom">
    <ul #tree class="hierarchy-tree" [ngClass]="'orientation-' + orientation">
      <ng-container *ngTemplateOutlet="branch; context: { $implicit: roots }"></ng-container>
    </ul>
  </div>
</div>

<ng-template #branch let-nodes>
  <ng-container *ngIf="groupChildren(nodes) as group">
    <!-- Siblings without teams of their own, wrapped into a grid (compact layout only) -->
    <li *ngIf="group.leaves" class="leaf-group first"
        [class.last]="!group.branches.length" [class.only]="!group.branches.length">
      <ul class="compact" [style.grid-template-columns]="group.columns">
        <li *ngFor="let node of group.leaves; trackBy: trackByUid">
          <ng-container *ngTemplateOutlet="nodeView; context: { $implicit: node }"></ng-container>
        </li>
      </ul>
    </li>
    <li *ngFor="let node of group.branches; trackBy: trackByUid; let first = first; let last = last"
        [class.first]="first && !group.leaves" [class.last]="last" [class.only]="first && last && !group.leaves">
      <ng-container *ngTemplateOutlet="nodeView; context: { $implicit: node }"></ng-container>
    </li>
  </ng-container>
</ng-template>

<ng-template #nodeView let-node>
  <div class="hierarchy-node" [attr.data-uid]="node.uid">
    <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node }"></ng-container>
  </div>
  <ul *ngIf="node.expanded && visible(node.children).length">
    <ng-container *ngTemplateOutlet="branch; context: { $implicit: node.children }"></ng-container>
  </ul>
</ng-template>
